import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ClockCounterClockwise, CaretDown } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const KIND_DOT = {
  created: 'bg-stone-400', saved: 'bg-yellow-400', completed: 'bg-green-500', reopened: 'bg-amber-500',
  monitored: 'bg-teal-600', unmonitored: 'bg-stone-500', invalidated: 'bg-orange-500',
  query_opened: 'bg-red-500', query_closed: 'bg-emerald-600',
};

const fmtDate = (iso, lang) => (iso ? new Date(iso).toLocaleDateString(lang === 'es' ? 'es-ES' : 'en-GB') : '');

// Historial (hitos) al pie del cuestionario: plegado, solo fechas.
export const QuestionnaireHistory = ({ studyId, target, refreshKey, lang }) => {
  const es = lang === 'es';
  const [open, setOpen] = useState(false);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    if (!target) return;
    const params = new URLSearchParams({
      visit_id: target.visit_id, questionnaire_id: target.questionnaire_id, entry_index: String(target.entry_index || 0),
    });
    axios.get(`${API_URL}/api/studies/${studyId}/volunteers/${target.volunteer_id}/visit-responses/history?${params}`, { withCredentials: true })
      .then(r => setEvents(r.data || [])).catch(() => setEvents([]));
  }, [studyId, target?.volunteer_id, target?.visit_id, target?.questionnaire_id, target?.entry_index, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!target) return null;
  return (
    <div className="mt-4 rounded-sm border border-stone-200 bg-stone-50/60" data-testid="fq-history">
      <button type="button" data-testid="fq-history-toggle" onClick={() => setOpen(v => !v)}
        className="flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm font-medium text-stone-700 hover:bg-stone-100/70">
        <ClockCounterClockwise size={15} className="text-stone-500" />
        {es ? 'Historial del cuestionario' : 'Questionnaire history'}
        <span className="text-xs text-stone-400">({events.length})</span>
        <CaretDown size={12} className={`ml-auto text-stone-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <ol className="border-t border-stone-200 px-4 py-3 space-y-2" data-testid="fq-history-list">
          {events.length === 0 && <li className="text-xs text-stone-400">{es ? 'Sin registros todavía.' : 'No records yet.'}</li>}
          {events.map((ev, i) => (
            <li key={i} className="flex items-start gap-3 text-xs" data-testid={`fq-history-item-${i}`}>
              <span className="w-20 shrink-0 font-mono text-stone-500">{fmtDate(ev.at, lang)}</span>
              <span className={`mt-1 h-2 w-2 shrink-0 rounded-full ${KIND_DOT[ev.kind] || 'bg-stone-400'}`} />
              <span className="min-w-0 text-stone-700">
                <span className="font-semibold text-stone-800">{ev.label}</span>
                {ev.by && <> · {ev.by}</>}
                {ev.role && <span className="text-stone-400"> ({ev.role})</span>}
                {ev.detail && <span className="block text-stone-500">{ev.detail}</span>}
              </span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
